import { InputSearchPro } from 'components/InputSearch';
import { empresaToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: null,
    fields: [
      'descripcion',
      'unidad_recaudadora',
      'empresa',
      'numero_de_permiso',
      'fecha_de_vigencia_permiso',
      'tipo_de_alcohol',
      'clase_de_actividad_empresarial',
      'giro_de_alcohol',
    ],
  },
];

const configs = {
  descripcion: {
    formItemProps: {
      label: 'Descripción',
    },
    required: false,
  },
  tipo_de_alcohol: {
    formItemProps: {
      label: 'Tipo de alcohol',
    },
  },
  giro_de_alcohol: {
    formItemProps: {
      label: 'Giro de alcohol',
    },
  },
  numero_de_permiso: {
    formItemProps: {
      label: 'Número de permiso',
    },
  },
  unidad_recaudadora: {
    formItemProps: {
      label: 'Unidad Recaudadora',
    },
  },
  empresa: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
    // rules: [{ required: true }],
  },
  fecha_de_vigencia_permiso: {
    formItemProps: {
      label: 'Fecha de vigencia de permiso',
    },
  },
  clase_de_actividad_empresarial: {
    formItemProps: {
      label: 'Clase de actividad empresarial',
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
